import gql from 'graphql-tag'

export const DOWNLOAD_BATCH = gql`
  query DownloadBatch($ids: [ID!]!) {
    downloadBatch(ids: $ids) {
      path
      link
    }
  }
`
